var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47059 24.9988C1.47059 12.0272 12.0268 1.47059 25.0006 1.47059C37.9731 1.47059 48.5294 12.0282 48.5294 25C48.5294 37.9718 37.9731 48.5294 25.0006 48.5294C12.0269 48.5294 1.47059 37.9706 1.47059 24.9988Z",
    stroke: "#4AC600",
    strokeWidth: 2.94118
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1639 19.8385L35.1634 19.839C32.6917 22.3157 30.2251 24.796 27.7611 27.2786C27.7609 27.2787 27.7608 27.2789 27.7606 27.2791L24.5215 30.5331L24.5203 30.5343C23.9998 31.0597 23.4783 31.5837 22.9557 32.1051C22.6703 32.3885 22.3681 32.5073 22.0803 32.5073C21.7948 32.5073 21.4977 32.3911 21.2171 32.1135C21.2168 32.1132 21.2165 32.1129 21.2161 32.1126L15.1884 26.0884L15.188 26.088C14.7578 25.6587 14.6887 25.291 14.7984 24.9306L14.7992 24.9278C14.9406 24.4562 15.2473 24.1675 15.7414 24.0539C16.0545 23.9832 16.3703 24.0563 16.7118 24.3977C17.6081 25.2965 18.5079 26.1951 19.4047 27.0907C19.4048 27.0908 19.4049 27.0908 19.4049 27.0909L21.5671 29.2519L22.0549 29.7394L22.5422 29.2514L27.6538 24.1322C27.6539 24.1322 27.6539 24.1321 27.654 24.132C29.5812 22.2035 31.5072 20.2738 33.4342 18.3431L33.4468 18.3305L33.4468 18.3304C33.6891 18.0876 33.905 17.9647 34.0915 17.9118C34.2715 17.8607 34.4671 17.8622 34.6988 17.9392L34.7006 17.9397C35.07 18.0614 35.3896 18.405 35.4847 18.8056C35.5683 19.1628 35.4688 19.5336 35.1639 19.8385Z",
    fill: "#4AC600",
    stroke: "#4AC600",
    strokeWidth: 1.37868
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneTick);
export default __webpack_public_path__ + "static/media/doneTick.bd46e35d.svg";
export { ForwardRef as ReactComponent };